<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->
<div class="row no-pad no-margin">
  <div class="dta_title mar-tb-20 pad-lr-15 col-md-3">{{'TODO' | translate}}</div>
  <div class="col-md-6 mar-tb-20 pad-lr-15" style="font-size: 20px;" *ngIf="checkOperationType">
    <span style="font-weight: bold;"> Operation Type: </span> 
    <span style="color: blue;">{{this.userOperationType | translate}}</span>
  </div>
  <div class="col-md-9 pad-top-15">
    <!--Show Supplier Coed Filtering for SM, SM-VS, Logistics Users -->
    <div class="row" *ngIf="userRoleID != 1 && userRoleID != 4">
      <div class="col-md-5 text-right pad-top-10">
        {{'Select Supplier Code' | translate}} &nbsp;&nbsp;&nbsp;
      </div>
      <div class="col-md-6 search_input input-group custom-search-form">
        <ng-multiselect-dropdown *ngIf="suppCodeList" name="suppliercode" 
        [settings]="dropdownSettings2" [data]="suppCodeList" [(ngModel)]="supPoint">
        </ng-multiselect-dropdown>
        <span class="input-group-btn">
          <button class="btn btn-light" type="button" (click)="onChangeUnderReviewTable(underReview_config)">
            {{'Search' | translate}}
          </button>
        </span>
      </div>

    </div>
    <!--Show Delivery Point Filtering only for Operation Users -->
    <div class="row delPntFilter" *ngIf="userRoleID == 4 && !checkOperationType && !opmScDpShow">
      <div class="col-md-5 text-right pad-top-10">
        {{'Select the Next Process' | translate}} &nbsp;&nbsp;&nbsp;
      </div>
      <div class="col-md-6 search_input input-group custom-search-form">
        <ng-multiselect-dropdown *ngIf="lineNoList"  [settings]="dropdownSettings" [data]="lineNoList" [(ngModel)]="lineNoFilter"
        (onSelect)="onNextProcessChange($event)" (onDeSelect)="onNextProcessChange($event)">
        </ng-multiselect-dropdown>
        <span class="input-group-btn" *ngIf="lineNoList">
          <button class="btn btn-light" type="button" (click)="onChangeUnderReviewTable(underReview_config)" [disabled]="disableNextProcessSearch">
            {{'Search' | translate}}
          </button>
        </span>
        <!--
          <div class="ORText text-primary"><b>OR</b></div>
        -->
      </div>
    </div>

    <div class="row delPntFilter" *ngIf="userRoleID == 4 && !checkOperationType && opmScDpShow">
      <div class="col-md-5 text-right pad-top-10">
        Select the Delivery Point &nbsp;&nbsp;&nbsp;
      </div>
      <div class="col-md-6 search_input input-group custom-search-form">
        <ng-multiselect-dropdown *ngIf="opmDeliveryPointDropdownData" [settings]="dropdownSettings4" [data]="opmDeliveryPointDropdownData" [(ngModel)]="opmDeliveryPointFilter" 
        (onSelect)="onOMDeliveryPointChange($event)" (onDeSelect)="onOMDeliveryPointChangeDeselect($event)">
        </ng-multiselect-dropdown>
        <span class="input-group-btn" *ngIf="lineNoList">
          <button class="btn btn-light" type="button" (click)="onChangeUnderReviewTable(underReview_config)" [disabled]="ovarAllAction">
            {{'Search' | translate}}
          </button>
        </span>
      </div>
    </div>


    <br>
    <!--
      <div class="row" *ngIf="userRoleID == 4 && opmScDpShow">
      <div class="row col-md-6">
      <div class="col-md-5 text-right pad-top-10">
       Select the Supplier Code &nbsp;&nbsp;&nbsp;
      </div>
      <div class="col-md-6 search_input input-group custom-search-form">
        <angular2-multiselect *ngIf="opmSupplierCodeDropdownData" [data]="opmSupplierCodeDropdownData" [(ngModel)]="opmDSupplierCodeFilter" [settings]="dropdownSettings3"
        (onSelect)="onOMSupplierCodeChange($event)" (onDeSelect)="onOMSupplierCodeChangeDeselect($event)">
        </angular2-multiselect>
      </div>
    </div>
    <div class="row col-md-6 delPntFilter1">
      <div class="col-md-5 text-right pad-top-10">
        Select the Delivery Point &nbsp;&nbsp;&nbsp;
      </div>
      <div class="col-md-6 search_input input-group custom-search-form">
        <angular2-multiselect *ngIf="opmDeliveryPointDropdownData" [data]="opmDeliveryPointDropdownData" [(ngModel)]="opmDeliveryPointFilter" [settings]="dropdownSettings4"
        (onSelect)="onOMDeliveryPointChange($event)" (onDeSelect)="onOMDeliveryPointChangeDeselect($event)">
        </angular2-multiselect>
        <span class="input-group-btn" *ngIf="lineNoList">
          <button class="btn btn-light" type="button" (click)="onChangeUnderReviewTable(underReview_config)" [disabled]="ovarAllAction">
            {{'Search' | translate}}
          </button>
        </span>
      </div>
      </div>
    </div>
    -->
    <br>
  </div>
</div>
<mat-accordion [multi]=false >
  <mat-expansion-panel #panelid [id]="'static-1'" *ngIf="userRoleID == 1" (opened)="beforeChange(panelid.id)">
    <mat-expansion-panel-header>
      <mat-panel-title>
      <span><strong>{{'NEWPARTS' | translate}}</strong></span>
      <span class="accArrow"></span>
      <span class="fullpage_icon"></span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="row mar-btm-10">
      <div class="col-md-9">
        <div class="text-left" [hidden]="newPartsAccData?.length == 0">{{'SHOWINGRESULT5' | translate}}</div>
      </div>
      <div class="col-md-3">
        <div class="text-right" [hidden]="newPartsAccData?.length == 0" (click)="openDetail(newDetailPage)">
          <span class="accViewAll partno_column">{{'VIEWALL' | translate}}</span>
          <span class="viewall_icon"></span>
        </div>
      </div>
    </div>
    <mat-panel-description>
      <table class="table table-bordered accordionTbl">
        <thead class="accordionHead">
          <tr>
            <th class=" text-center">{{'PARTNO' | translate}}</th>
            <th class=" text-center">{{'PACKAGEID' | translate}}</th>
            <th class=" text-center">{{'PARTNAME' | translate}}</th>
            <th class=" text-center">{{'ASSIGNEDDATE' | translate}}</th>
            <th class=" text-center">{{'LASTUPDATE' | translate}}</th>
            <th class=" text-center">{{'DUEDATE' | translate}}</th>
          </tr>
        </thead>
        <tbody class="nicescrolled">
          <tr *ngFor="let item of newPartsAccData | slice:0:5">
            <td class=" text-center hasLink partno_column" (click)="todoPkgRoute(item)">{{item.partNumber}}</td>
            <td class=" text-center hasLink partno_column" (click)="todoPkgRoute(item)">{{item.packageId}}</td>
            <td class="text-center">{{item.partName}}</td>
            <td class="text-center cell-ellipse">{{item.assignedDate | date:'yyyy-MM-dd' }}</td>
            <td class="text-center cell-ellipse">{{item.updatedDate | date:'yyyy-MM-dd'}}</td>
            <td class="text-center cell-ellipse">{{item.dueDated | date:'yyyy-MM-dd'}}</td>
          </tr>
          <tr *ngIf="newPartsAccData?.length <= 0">
            <td colspan="9" class="text-center">{{'No Records Found' | translate}}</td>
          </tr>
        </tbody>
      </table>

    </mat-panel-description>
  </mat-expansion-panel>
  <mat-expansion-panel #panelid1 [id]="'static-2'" *ngIf="userRoleID == 1" (opened)="beforeChange(panelid1.id)">
    <mat-expansion-panel-header>
      <mat-panel-title>
      <span><strong>{{'INPROGRESS' | translate}}</strong></span>
      <span class="accArrow"></span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="row mar-btm-10">
      <div class="col-md-9">
        <div class="text-left" [hidden]="ipPartsAccData?.length == 0">{{'SHOWINGRESULT5' | translate}}</div>
      </div>
      <div class="col-md-3">
        <div class="text-right" [hidden]="ipPartsAccData?.length == 0" (click)="openDetail(inProgressdetailPage)">
          <span class="accViewAll partno_column">{{'VIEWALL' | translate}}</span>
          <span class="viewall_icon"></span>
        </div>
      </div>
    </div>
    <mat-panel-description>

      <table class="table table-bordered accordionTbl">
        <thead class="accordionHead">
          <tr>
            <th class=" text-center">{{'PARTNO' | translate}}</th>
            <th class=" text-center">{{'PACKAGEID' | translate}}</th>
            <th class=" text-center">{{'PARTNAME' | translate}}</th>
            <th class=" text-center">{{'ASSIGNEDDATE' | translate}}</th>
            <th class=" text-center">{{'LASTUPDATE' | translate}}</th>
            <th class=" text-center">{{'DUEDATE' | translate}}</th>
            <!-- <th class="col-md-1">History</th> -->
          </tr>
        </thead>
        <tbody class="nicescrolled">
          <tr *ngFor="let item of ipPartsAccData | slice:0:5">
            <td class=" text-center hasLink partno_column" (click)="todoPkgRoute(item)">{{item.partNumber}}</td>
            <td class=" text-center hasLink partno_column" (click)="todoPkgRoute(item)">{{item.packageId}}</td>
            <td class=" text-center">{{item.partName}}</td>
            <td class=" text-center cell-ellipse">{{item.assignedDate | date:'yyyy-MM-dd'}}</td>
            <td class=" text-center cell-ellipse">{{item.updatedDate | date:'yyyy-MM-dd'}}</td>
            <td class=" text-center cell-ellipse">{{item.dueDated | date:'yyyy-MM-dd'}}</td>
            <!-- <td class="col-md-1 ">
              <div class="history_img" (click)="open(history)"></div>
            </td> -->
          </tr>
          <tr *ngIf="ipPartsAccData?.length <= 0">
            <td colspan="9" class="text-center">{{'No Records Found' | translate}}</td>
          </tr>
        </tbody>
      </table>

    </mat-panel-description>
  </mat-expansion-panel>
  <mat-expansion-panel #panelid2 [id]="'static-3'" *ngIf="userRoleID != 1 && userRoleID !=11" [expanded]="true"  (opened)="beforeChange(panelid2.id)">
    <mat-expansion-panel-header>
      <mat-panel-title>
      <span><strong>{{'UNDEREVIEW' | translate}}</strong></span>
      <span class="accArrow"></span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="row mar-btm-10">
      <div class="col-md-9">
        <div class="text-left" [hidden]="urPartsAccData?.length == 0">{{'SHOWINGRESULT5' | translate}}</div>
      </div>
      <div class="col-md-3">
        <div class="text-right" [hidden]="urPartsAccData?.length == 0" (click)="openDetail(underReviewPage)">
          <span class="accViewAll partno_column">{{'VIEWALL' | translate}}</span>
          <span class="viewall_icon"></span>
        </div>
      </div>
    </div>
    <mat-panel-description>


      <table class="table table-bordered accordionTbl">
        <thead class="accordionHead">
          <tr>
            <th class=" text-center">{{'PARTNO' | translate}}</th>
            <th class=" text-center">{{'PACKAGEID' | translate}}</th>
            <th class=" text-center">{{'PARTNAME' | translate}}</th>
            <th class=" text-center">{{'ASSIGNEDDATE' | translate}}</th>
            <th class=" text-center">{{'LASTUPDATE' | translate}}</th>
            <th class=" text-center">{{'DUEDATE' | translate}}</th>
            <!-- <th class="col-md-1">History</th> -->
          </tr>
        </thead>
        <tbody class="nicescrolled">
          <tr *ngFor="let item of urPartsAccData | slice:0:5">
            <td class=" text-center hasLink partno_column" (click)="todoPkgRoute(item)">{{item.partNumber}}</td>
            <td class=" text-center hasLink partno_column" (click)="todoPkgRoute(item)">{{item.packageId}}</td>
            <td class=" text-center">{{item.partName}}</td>
            <td class=" text-center cell-ellipse">{{item.assignedDate | date:'yyyy-MM-dd'}}</td>
            <td class=" text-center cell-ellipse">{{item.updatedDate | date:'yyyy-MM-dd'}}</td>
            <td class=" text-center cell-ellipse">{{item.dueDated | date:'yyyy-MM-dd'}}</td>
            <!-- <td class="col-md-1 ">
              <div class="history_img" (click)="open(history)"></div>
            </td> -->
          </tr>
          <tr *ngIf="urPartsAccData?.length <= 0">
            <td colspan="9" class="text-center">{{'No Records Found' | translate}}</td>
          </tr>
        </tbody>
      </table>

    </mat-panel-description>
  </mat-expansion-panel>
  <mat-expansion-panel #panelid3 [id]="'static-4'" *ngIf="userRoleID == 1" (opened)="beforeChange(panelid3.id)">
    <mat-expansion-panel-header>
      <mat-panel-title>
      <span><strong>{{'REJECTED' | translate}}</strong></span>
      <span class="accArrow"></span>
      <span class="fullpage_icon" (click)="open(detailPage)"></span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="row mar-btm-10">
      <div class="col-md-9">
        <div class="text-left" [hidden]="rejPartsAccData?.length == 0">{{'SHOWINGRESULT5' | translate}}</div>
      </div>
      <div class="col-md-3">
        <div class="text-right" [hidden]="rejPartsAccData?.length == 0" (click)="openDetail(rejectedDetailPage)">
          <span class="accViewAll partno_column">{{'VIEWALL' | translate}}</span>
          <span class="viewall_icon"></span>
        </div>
      </div>
    </div>
    <mat-panel-description>
      
      <table class="table table-bordered accordionTbl">
        <thead class="accordionHead">
          <tr>
            <th class=" text-center">{{'PARTNO' | translate}}</th>
            <th class=" text-center">{{'PACKAGEID' | translate}}</th>
            <th class=" text-center">{{'PARTNAME' | translate}}</th>
            <th class=" text-center">{{'ASSIGNEDDATE' | translate}}</th>
            <th class=" text-center">{{'LASTUPDATE' | translate}}</th>
            <th class=" text-center">{{'COMMENTS' | translate}}</th>
            <!-- <th class="col-md-1">History</th> -->
          </tr>
        </thead>
        <tbody class="nicescrolled">
          <tr *ngFor="let item of rejPartsAccData">
            <td class="text-center hasLink partno_column" (click)="todoPkgRoute(item)">{{item.partNumber}}</td>
            <td class="text-center hasLink partno_column" (click)="todoPkgRoute(item)">{{item.packageId}}</td>
            <td class="text-center">{{item.partName}}</td>
            <td class="text-center cell-ellipse">{{item.assignedDate | date:'yyyy-MM-dd'}}</td>
            <td class="text-center cell-ellipse">{{item.updatedDate | date:'yyyy-MM-dd'}}</td>
            <td class="text-center cell-ellipse">{{item.comments}}</td>
            <!-- <td class="col-md-1 ">
              <div class="history_img" (click)="open(history)"></div>
            </td> -->
          </tr>
          <tr *ngIf="rejPartsAccData?.length <= 0">
            <td colspan="9" class="text-center">{{'No Records Found' | translate}}</td>
          </tr>
        </tbody>
      </table>
    </mat-panel-description>
  </mat-expansion-panel>
</mat-accordion>



<ng-template #newDetailPage let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{'NEWPARTS' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- <section class="part_search_bar">
      <div class="row ">
        <div class=" offset-md-3 col-md-6 search_input">
          <input *ngIf="newPart_config.filtering" placeholder="{{'SEARCHBY' | translate}}" [ngTableFiltering]="newPart_config.filtering"
            class="form-control" (tableChanged)="onChangeNewPartTable(newPart_config)" />
        </div>
      </div>
    </section> -->
    <div class="row">
      <div class="col-md-6 mx-auto">
        <div class="input-group custom-search-form" *ngIf="newPart_config.filtering">
          <input placeholder="{{'SEARCHBY' | translate}}"  class="form-control" [(ngModel)]="srch_newpart"
            placeholder="{{'SEARCHBY' | translate}}">
          <span class="input-group-btn">
            <button class="btn btn-light" type="button" (click)="onChangeNewPartTable(newPart_config)">
              {{'Search' | translate}}
            </button>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 mar-btm-30">
        <!-- <pagination *ngIf="newPart_config.paging" class="pagination-sm pull-right pad-top-10" [(ngModel)]="page"
          [totalItems]="newpartslength" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true"
          [rotate]="false" (pageChanged)="onChangeNewPartTable(newPart_config, $event)" (numPages)="numPages = $event">
        </pagination>
         <ng-table [config]="newPart_config" (tableChanged)="onChangeNewPartTable(newPart_config)" [rows]="newPartsRow"
          [columns]="newPart_columns" (cellClicked)="onCellClick($event)">
        </ng-table> -->


        <pagination *ngIf="newPart_config.paging" class="pad-top-10" [(ngModel)]="page"
          [totalItems]="newpartslength" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true"
          [rotate]="false" (pageChanged)="onChangeNewPartTable(newPart_config, $event)" (numPages)="numPages = $event">
        </pagination>
        
        <div class="example-container mat-elevation-z8">
        
          <mat-table [dataSource]="dataSource_newparts" matSort>
        
            <!-- ID Column -->
            <ng-container matColumnDef="partNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Part Number </mat-header-cell>
              <mat-cell *matCellDef="let row"><a class="partno_column" [routerLink] ="['/partDetails/partsInfo/', row.packageId]" routerLinkActive="router-link-active" (click)="onCellClick($event)">{{row.partNumber}}</a> </mat-cell>
            </ng-container>
        
            <!-- Progress Column -->
            <ng-container matColumnDef="partName">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Part Name </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{row.partName}} </mat-cell>
            </ng-container>
        
            <!-- Name Column -->
            <ng-container matColumnDef="updatedDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Updated Date </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{row.updatedDate}} </mat-cell>
            </ng-container>
        
            <!-- Color Column -->
            <ng-container matColumnDef="assignedDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Assigned Date </mat-header-cell>
              <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.assignedDate}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="dueDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Due Date </mat-header-cell>
              <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.dueDated}} </mat-cell>
            </ng-container>
        
            <mat-header-row *matHeaderRowDef="newparts_data"></mat-header-row>
            <mat-row *matRowDef="let row; columns: newparts_data;">
            </mat-row>
          </mat-table>
      </div>
        

        


    </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'Close' | translate}}</button>
  </div>
</ng-template>

<ng-template #inProgressdetailPage let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" *ngIf="userRoleID == 1">{{'INPROGRESS' | translate}}</h4>
    <!-- <h4 class="modal-title" *ngIf="userRoleID != 1">{{'UNDEREVIEW' | translate}}</h4>  -->
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-6 mx-auto">
        <div class="input-group custom-search-form" *ngIf="inprogress_config.filtering">
          <input placeholder="{{'SEARCHBY' | translate}}"  class="form-control"
            placeholder="{{'SEARCHBY' | translate}}" [(ngModel)]="srch_inprogress">
          <span class="input-group-btn">
            <button class="btn btn-light" type="button" (click)="onChangeInprogressTable(inprogress_config)">
              {{'Search' | translate}}
            </button>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 mar-btm-30">
        <!-- <pagination *ngIf="inprogress_config.paging" class="pagination-sm pull-right pad-top-10" [(ngModel)]="page"
          [totalItems]="inProgresslength" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true"
          [rotate]="false" (pageChanged)="onChangeInprogressTable(inprogress_config, $event)" (numPages)="numPages = $event">
        </pagination>
       <ng-table [config]="inprogress_config" (tableChanged)="onChangeInprogressTable(inprogress_config)" [rows]="inProgressRow"
          [columns]="inprogress_columns" (cellClicked)="onCellClick($event)">
        </ng-table> -->

        <pagination *ngIf="inprogress_config.paging" class="pad-top-10" [(ngModel)]="page"
          [totalItems]="inProgresslength" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true"
          [rotate]="false" (pageChanged)="onChangeInprogressTable(inprogress_config, $event)" (numPages)="numPages = $event">
        </pagination>
        <div class="example-container mat-elevation-z8">
        
          <mat-table [dataSource]="dataSource_inprogress" matSort>
        
            <!-- ID Column -->
            <ng-container matColumnDef="partNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Part Number </mat-header-cell>
              <mat-cell *matCellDef="let row"> <a class="partno_column" [routerLink] ="['/partDetails/partsInfo/', row.packageId]" routerLinkActive="router-link-active" (click)="onCellClick($event)">{{row.partNumber}}</a> </mat-cell>
            </ng-container>
        
            <!-- Progress Column -->
            <ng-container matColumnDef="partName">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Part Name </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{row.partName}} </mat-cell>
            </ng-container>
        
            <!-- Name Column -->
            <ng-container matColumnDef="updatedDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Updated Date </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{row.updatedDate}} </mat-cell>
            </ng-container>
        
            <!-- Color Column -->
            <ng-container matColumnDef="assignedDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Assigned Date </mat-header-cell>
              <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.assignedDate}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="dueDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Due Date </mat-header-cell>
              <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.dueDated}} </mat-cell>
            </ng-container>
        
            <mat-header-row *matHeaderRowDef="inprogress_data"></mat-header-row>
            <mat-row *matRowDef="let row; columns: inprogress_data;">
            </mat-row>
          </mat-table>
      </div>
    </div>
  </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'Close' | translate}}</button>
  </div>
</ng-template>



<ng-template #underReviewPage let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{'UNDEREVIEW' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-6 mx-auto">
        <div class="input-group custom-search-form" *ngIf="underReview_config.filtering">
          <input placeholder="{{'SEARCHBY' | translate}}" [(ngModel)]="srch_underReview" class="form-control"
            placeholder="{{'SEARCHBY' | translate}}">
          <span class="input-group-btn">
            <button class="btn btn-light" type="button" (click)="onChangeUnderReviewTable(underReview_config)">
              {{'Search' | translate}}
            </button>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 mar-btm-30">
        <!-- <pagination *ngIf="underReview_config.paging" class="pagination-sm pull-right pad-top-10" [(ngModel)]="page"
          [totalItems]="urpartslength" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true"
          [rotate]="false" (pageChanged)="onChangeUnderReviewTable(underReview_config, $event)" (numPages)="numPages = $event">
        </pagination>
         <ng-table [config]="underReview_Config" (tableChanged)="onChangeUnderReviewTable(underReview_config)" [rows]="underReviewRow"
          [columns]="underReview_columns" (cellClicked)="onCellClick($event)">
        </ng-table> -->

        <pagination *ngIf="underReview_config.paging" class="pad-top-10" [(ngModel)]="page"
          [totalItems]="urpartslength" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true"
          [rotate]="false" (pageChanged)="onChangeUnderReviewTable(underReview_config, $event)" (numPages)="numPages = $event">
        </pagination>

        <div class="example-container mat-elevation-z8">
        
          <mat-table [dataSource]="dataSource_underReview" matSort>
        
            <!-- ID Column -->
            <ng-container matColumnDef="partNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Part Number </mat-header-cell>
              <mat-cell *matCellDef="let row">  <a class="partno_column" [routerLink] ="['/partDetails/partsInfo/', row.packageId]" routerLinkActive="router-link-active">{{row.partNumber}}</a>  </mat-cell>
            </ng-container>
        
            <!-- Progress Column -->
            <ng-container matColumnDef="partName">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Part Name </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{row.partName}} </mat-cell>
            </ng-container>
        
            <!-- Name Column -->
            <ng-container matColumnDef="updatedDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Updated Date </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{row.updatedDate}} </mat-cell>
            </ng-container>
        
            <!-- Color Column -->
            <ng-container matColumnDef="assignedDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Assigned Date </mat-header-cell>
              <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.assignedDate}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="dueDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Due Date </mat-header-cell>
              <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.dueDated}} </mat-cell>
            </ng-container>
        
            <mat-header-row *matHeaderRowDef="underReview_data"></mat-header-row>
            <mat-row *matRowDef="let row; columns: underReview_data;">
            </mat-row>
          </mat-table>
      </div>

        
    </div>
  </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'Close' | translate}}</button>
  </div>
</ng-template>

<ng-template #rejectedDetailPage let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{'REJECTED' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-6 mx-auto">
        <div class="input-group custom-search-form" *ngIf="rejected_config.filtering">
          <input placeholder="{{'SEARCHBY' | translate}}" [(ngModel)]="srch_rejected" class="form-control"
            placeholder="{{'SEARCHBY' | translate}}">
          <span class="input-group-btn">
            <button class="btn btn-light" type="button" (click)="onChangeRejectedTable(rejected_config)">
              {{'Search' | translate}}
            </button>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 mar-btm-30">
        <!-- <pagination *ngIf="rejected_config.paging" class="pagination-sm pull-right pad-top-10" [(ngModel)]="page"
          [totalItems]="rej_length" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false"
          (pageChanged)="onChangeRejectedTable(rejected_config, $event)" (numPages)="numPages = $event">
        </pagination>
        <ng-table [config]="rejected_config" (tableChanged)="onChangeRejectedTable(rejected_config)" [rows]="rejectedRow"
          [columns]="rejected_columns" (cellClicked)="onCellClick($event)">
        </ng-table> -->
        <pagination *ngIf="rejected_config.paging" class="pad-top-10" [(ngModel)]="page"
          [totalItems]="rej_length" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false"
          (pageChanged)="onChangeRejectedTable(rejected_config, $event)" (numPages)="numPages = $event">
        </pagination>


        <div class="example-container mat-elevation-z8">
        
          <mat-table [dataSource]="dataSource_rejected" matSort>
        
            <!-- ID Column -->
            <ng-container matColumnDef="partNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Part Number </mat-header-cell>
              <mat-cell *matCellDef="let row"><a class="partno_column" [routerLink] ="['/partDetails/partsInfo/', row.packageId]" routerLinkActive="router-link-active" (click)="onCellClick($event)">{{row.partNumber}}</a> </mat-cell>
            </ng-container>
        
            <!-- Progress Column -->
            <ng-container matColumnDef="partName">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Part Name </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{row.partName}} </mat-cell>
            </ng-container>
        
            <!-- Name Column -->
            <ng-container matColumnDef="updatedDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Updated Date </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{row.updatedDate}} </mat-cell>
            </ng-container>
        
            <!-- Color Column -->
            <ng-container matColumnDef="assignedDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Assigned Date </mat-header-cell>
              <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.assignedDate}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="comments">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Comments </mat-header-cell>
              <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.comments}} </mat-cell>
            </ng-container>
        
            <mat-header-row *matHeaderRowDef="rejected_data"></mat-header-row>
            <mat-row *matRowDef="let row; columns: rejected_data;">
            </mat-row>
          </mat-table>
      </div>


    </div>
  </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'Close' | translate}}</button>
  </div>
</ng-template>